import MyNewsDeskListPage from './MyNewsDeskListPage';

export default MyNewsDeskListPage;
